import axios from 'axios';
import config from '../config';

const API_URL = `${config.API_BASE_URL}/filters`;

export const fetchFilters = async () => {
  const res = await axios.get(API_URL);
  return res.data;
};
